module.exports = __webpack_public_path__ + "img/extended.ec842843.png";